/* eslint-disable no-restricted-syntax */
/**
 * Aquí se definiran los enums que se utilizan en el módulo de inventario
 */

export const enum Magnitud {
    LONGITUD = 'longitud',
    TIEMPO = 'tiempo',
    AREA = 'area',
    VOLUMEN = 'volumen',
    TEMPERATURA = 'temperatura',
    UNITARIO = 'unitario',
    MASA = 'masa',
    DENSIDAD = 'densidad',
    PESO_ESPECIFICO = 'peso_especifico',
    ANGULO = 'angulo',
    OTRO = 'otro',
}

export const enum EstadoItem {
    NUEVO = 'nuevo',
    USADO = 'usado',
    REMANUFACTURADO = 'remanofacturado',
}

export const enum CosteoBodega {
    LIFO = 'lifo',
    FIFO = 'fifo',
    AVERAGE = 'avg',
}

export const enum TipoSolicitud {
    CONSUMO = 'consumo',
    DEVOLUCION = 'devolucion',
    TRANSFERENCIA = 'transferencia',
}
